import { connectDashboard } from '../../redux/dashboard'
import App from '../../components/App'

export default connectDashboard()(App)



// WEBPACK FOOTER //
// ./src/containers/App/index.js